// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l95Dy","rootNoMargin":"styles_rootNoMargin__2fpmV"};